{
  "queryName": "pendingMaintenanceRequests",
  "queryParam": null,
  "fields": [
    "id",
    "createdAt",
    {
      "name": "fairsharingRecord",
      "fields": [
        "id",
        "name",
        "type",
        {
          "queryName": "processingNotes",
          "fields": ["id", "note"]
        },
        {
          "queryName": "lastEditor",
          "fields": ["id", "username"]
        }
      ]
    },
    {
      "name": "user",
      "fields": ["username", "id"]
    }
  ]
}
